import script from "./HeuresServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeuresServicesView.vue?vue&type=script&setup=true&lang=js"

import "./HeuresServicesView.vue?vue&type=style&index=0&id=965167f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965167f0"]])

export default __exports__